/**
 * Logout Page
 *
 * Simple page that signs the user out and redirects to landing page.
 */

import { onMount } from 'solid-js';
import { signOut } from '../lib/supabase';

export default function Logout() {
  onMount(async () => {
    await signOut();
    // Redirect to landing page after logout
    window.location.href = 'https://aigentswork.com';
  });

  return (
    <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-gray-950">
      <div class="text-center">
        <div class="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-purple-600 to-pink-600 rounded-2xl mb-4 shadow-lg shadow-purple-500/30">
          <svg
            class="w-8 h-8 text-white animate-spin"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            />
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
        <p class="text-gray-400">Signing out...</p>
      </div>
    </div>
  );
}
